// src/components/SelectTacticForm.jsx
import React, { useState, useEffect } from 'react';

const SelectTacticForm = ({ quote, onSubmit, onCancel }) => {
  const [tactics, setTactics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [selectedTactic, setSelectedTactic] = useState('');
  const [justification, setJustification] = useState('');
  
  // Load tactics when component mounts
  useEffect(() => {
    const fetchTactics = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/admin/tactics');
        if (!response.ok) {
          throw new Error('Failed to fetch tactics');
        }
        const data = await response.json();
        setTactics(data);
      } catch (error) {
        console.error('Error fetching tactics:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchTactics();
  }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedTactic || !justification) {
      alert('All fields are required');
      return;
    }
    
    onSubmit({
      tactic_id: selectedTactic,
      justification
    });
  };
  
  if (loading) {
    return <div className="text-center py-4">Loading tactics...</div>;
  }
  
  if (error) {
    return (
      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
        <p className="font-bold">Error</p>
        <p>{error}</p>
      </div>
    );
  }
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <h4 className="font-medium text-lg mb-2">Connect Quote to Authoritarian Tactic</h4>
        <p className="text-sm text-gray-500 mb-4">
          Select an authoritarian tactic that this claim exemplifies or supports.
        </p>
      </div>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="tactic" className="block text-sm font-medium text-gray-700 mb-1">
            Authoritarian Tactic
          </label>
          <select
            id="tactic"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            value={selectedTactic}
            onChange={(e) => setSelectedTactic(e.target.value)}
            required
          >
            <option value="">Select a tactic</option>
            {tactics
              .sort((a, b) => a.playbook_step_number - b.playbook_step_number)
              .map((tactic) => (
                <option key={tactic.id} value={tactic.id}>
                  Step {tactic.playbook_step_number}: {tactic.name}
                </option>
              ))
            }
          </select>
        </div>
        
        <div>
          <label htmlFor="justification" className="block text-sm font-medium text-gray-700 mb-1">
            Justification
          </label>
          <textarea
            id="justification"
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            value={justification}
            onChange={(e) => setJustification(e.target.value)}
            placeholder="Explain how this claim exemplifies or supports this authoritarian tactic..."
            required
          ></textarea>
        </div>
      </div>
      
      <div className="flex justify-end pt-4 space-x-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-purple-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-purple-700"
        >
          Connect
        </button>
      </div>
    </form>
  );
};

export default SelectTacticForm;